export default __webpack_public_path__ + "cc18778318a25638eccd53740bfca512.png";